"use client";

import { useRef } from "react";
import { HandHeart, Moon, Scissors } from "lucide-react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useGSAP } from "@gsap/react";
import { Link } from "@/components/common/Link";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const values = [{
  icon: HandHeart,
  labelBefore: "",
  labelItalic: "Convenience",
  labelAfter: "",
  body: "We bring the premium detailing studio to your driveway or office. Save time while we restore your vehicle's showroom shine."
}, {
  icon: Scissors,
  labelBefore: "",
  labelItalic: "Precision",
  labelAfter: "",
  body: "Expert care for every surface. From paint correction to interior steam cleaning, we use only the finest professional products."
}, {
  icon: Moon,
  labelBefore: "",
  labelItalic: "Excellence",
  labelAfter: "",
  body: "Dedicated to perfection in every detail. Our team treats your car with the same care as if it were our own prized possession."
}];
export default function Whychoosevaleroelitedetailing() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".val-eyebrow", {
        y: 16
      });
      gsap.set(".val-heading", {
        y: 24
      });
      gsap.set(".val-lede", {
        y: 16
      });
      gsap.set(".val-cell", {
        y: 20
      });
      gsap.to(".val-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.9,
        ease: "power3.out",
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".val-heading", {
        opacity: 1,
        y: 0,
        duration: 1.1,
        ease: "power3.out",
        delay: 0.1,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".val-lede", {
        opacity: 1,
        y: 0,
        duration: 1.0,
        ease: "power3.out",
        delay: 0.25,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.to(".val-cell", {
        opacity: 1,
        y: 0,
        duration: 1.1,
        ease: "power3.out",
        stagger: 0.08,
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".val-eyebrow", ".val-heading", ".val-lede", ".val-cell"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="28633" id="whychoosevaleroelitedetailing" className="relative overflow-hidden text-foreground py-32 !bg-[rgba(9,9,12,1)] md:py-44 dark !bg-[url(https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/2c5adb21-78b8-414e-bdd9-7f8da4aa1a32.jpeg)] !bg-[url(https://inspired-chamois-1.cynergiasites.com/wp-content/uploads/2026/07/valero_detailing_gallery_02.webp)]">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]">
        <svg className="h-full w-full" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" fill="none">
          <g stroke="currentColor" strokeWidth="1" fill="none">
            <path d="M-100,720 C220,660 480,700 720,640 C960,580 1200,620 1560,560" />
            <path d="M-100,660 C240,600 500,640 740,580 C980,520 1220,560 1560,500" />
            <path d="M-100,600 C260,540 520,580 760,520 C1000,460 1240,500 1560,440" />
            <path d="M-100,540 C280,480 540,520 780,460 C1020,400 1260,440 1560,380" />
            <path d="M-100,480 C300,420 560,460 800,400 C1040,340 1280,380 1560,320" />
            <path d="M-100,420 C320,360 580,400 820,340 C1060,280 1300,320 1560,260" />
            <path d="M-100,360 C340,300 600,340 840,280 C1080,220 1320,260 1560,200" />
            <path d="M-100,300 C360,240 620,280 860,220 C1100,160 1340,200 1560,140" />
            <path d="M-100,240 C380,180 640,220 880,160 C1120,100 1360,140 1560,80" />
          </g>
        </svg>
      </div>

      <div aria-hidden="true" className="pointer-events-none absolute inset-0 z-10 bg-black/25" />

      <div ref={container} className="relative z-10 mx-auto w-full max-w-[1440px] px-5 !opacity-100 md:px-8 lg:px-12">
        {}
        <div className="mx-auto flex max-w-[640px] flex-col items-center text-center">
          <span className="val-eyebrow font-sans text-[0.75rem] font-medium uppercase" style={{
          opacity: 0,
          letterSpacing: "0.28em",
          color: "var(--muted-foreground)"
        }}>
            Why Choose Us
          </span>

          <h2 className="val-heading mt-5 font-serif font-normal" style={{
          opacity: 0,
          fontSize: "clamp(2.5rem, 5.5vw, 5rem)",
          lineHeight: 1.02,
          letterSpacing: "-0.015em",
          color: "var(--foreground)"
        }}>
            The Valero <em className="italic">Elite</em> standard.
          </h2>

          <p className="val-lede mt-5 font-sans" style={{
          opacity: 0,
          fontSize: "clamp(1.05rem, 1.2vw, 1.2rem)",
          lineHeight: 1.65,
          color: "var(--muted-foreground)"
        }}>
            Premium mobile detailing for your vehicle.
          </p>
        </div>

        {}
        <div className="mt-20 grid grid-cols-1 gap-16 md:mt-24 md:grid-cols-2 md:gap-10 lg:grid-cols-3 lg:gap-8">
          {values.map((v, i) => {
          const Icon = v.icon;
          return <div key={i} data-index={i} className="val-cell group flex flex-col items-center px-4 py-8 text-center md:px-6 md:py-12" style={{
            opacity: 0
          }}>
                <div className="flex h-10 w-10 items-center justify-center transition-colors duration-300" style={{
              color: "var(--primary)"
            }}>
                  <Icon className="h-10 w-10 transition-colors duration-300 group-hover:text-primary" strokeWidth={1.25} />
                </div>

                <h3 className="mt-8 font-serif font-normal" style={{
              fontSize: "clamp(1.25rem, 1.6vw, 1.5rem)",
              lineHeight: 1.15,
              letterSpacing: "0em",
              color: "var(--foreground)"
            }}>
                  {v.labelBefore}
                  <em className="italic">{v.labelItalic}</em>
                  {v.labelAfter}
                </h3>

                <p className="mt-5 max-w-[320px] font-sans" style={{
              fontSize: "1rem",
              lineHeight: 1.7,
              color: "var(--muted-foreground)"
            }}>
                  {v.body}
                </p>

                <Link to="https://inspired-chamois-1.cynergiasites.com/services-servicios/" className="mt-6 inline-flex items-center font-sans text-sm transition-colors duration-300" style={{
              color: "var(--foreground)",
              textDecoration: "underline",
              textDecorationColor: "var(--primary)",
              textUnderlineOffset: "4px",
              textDecorationThickness: "1px"
            }}>
                  <span>{"View Services \u2192"}</span>
                </Link>
              </div>;
        })}
        </div>
      </div>
    </section>;
}